import { inject, Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { map, Observable, take } from 'rxjs';
import { Store } from '@ngrx/store';
import { OrganizationsStore } from '../../store/organizations/organizations.model';
import { UserStore } from '../../store/user/user.model';
import { BinarbaseAvailabilityService } from '../../shared/services/binarbase/binarbase-availability.service';

@Injectable({
  providedIn: 'root',
})
export class AppBiEnabledGuard {
  readonly binarbaseAvailabilitySvc = inject(BinarbaseAvailabilityService);
  readonly router = inject(Router);
  readonly organization = inject(Store<OrganizationsStore>);
  readonly userStore = inject(Store<UserStore>);

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> {
    return this.isWflowBiEnabled(state);
  }

  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> {
    return this.isWflowBiEnabled(state);
  }

  private isWflowBiEnabled(state: RouterStateSnapshot) {
    const path = state.url;

    const isDocuments =
      /documents|incoming-invoices|outgoing-invoices|processing-efficiency|approval-efficiency/.test(
        path,
      );

    return this.binarbaseAvailabilitySvc.isBinarbaseBetaEnabled().pipe(
      take(1),
      map((enabled) => {
        if (enabled) {
          if (isDocuments) {
            return true;
          }

          return this.router.createUrlTree([
            'wflow-bi',
            'processing-efficiency',
          ]);
        }

        return this.router.createUrlTree(['/']);
      }),
    );
  }
}
